import app from "firebase/app";
import "firebase/database";
import "firebase/storage";
import "firebase/performance";
import "firebase/auth";

class Firebase {
  constructor() {}

  doInitiate = dbName => {
    //console.log("Doing fb init");
    let config = {};

    //console.log("yes it is brooklynz");
    //console.log(window.location.hostname);
    if (window.location.hostname === "app.brooklynzcommunitysupport.com") {
      console.log("rodp");
      config = {
        apiKey: "AIzaSyDy2xShHWWf7y_imfJp3JwwxO81SpI-MfY",
        authDomain: "bcs-fb-database.firebaseapp.com",
        databaseURL: "https://bcs-fb-database.firebaseio.com",
        projectId: "bcs-fb-database",
        storageBucket: "bcsfbtest",
        messagingSenderId: "506308287965",
        appId: "1:506308287965:web:c4757661f1911a16156a34"
      };
    } else {
      console.log("vedp");
      config = {
        apiKey: "AIzaSyDy2xShHWWf7y_imfJp3JwwxO81SpI-MfY",
        authDomain: "bcs-fb-database.firebaseapp.com",
        databaseURL: "https://bcs-fb-database.firebaseio.com",
        projectId: "bcs-fb-database",
        storageBucket: "bcsfbtest",
        messagingSenderId: "506308287965",
        appId: "1:506308287965:web:c4757661f1911a16156a34"
      };
      // config = {
      //   apiKey: "AIzaSyC8zPSIZ0D1hD4SCtkopZcfjKoSmH2d6oQ",
      //   authDomain: "bcs-fb-dev.firebaseapp.com",
      //   databaseURL: "https://bcs-fb-dev.firebaseio.com",
      //   projectId: "bcs-fb-dev",
      //   storageBucket: "bcsfbtest",
      //   messagingSenderId: "548075302244",
      //   appId: "1:548075302244:web:f3cbe772dd237dd9f21e71",
      //   measurementId: "G-3324ZXRXMJ"
      // };
    }

    //console.log("Initializing firebase");
    app.initializeApp(config);
    //console.log("Initialize completed");
    /* Helper */

    this.serverValue = app.database.ServerValue;
    this.emailAuthProvider = app.auth.EmailAuthProvider;
    this.phoneAuthProvider = app.auth.PhoneAuthProvider;

    //console.log("Session established: " + JSON.stringify(this.serverValue));
    /* Firebase APIs */

    this.auth = app.auth();
    this.db = app.database();
    this.storage = app.storage();
    this.perf = app.performance();
    this.dbUrl = config.databaseURL;
  };

  // *** Auth API ***

  doCreateUserWithEmailAndPassword = (email, password) =>
    this.auth.createUserWithEmailAndPassword(email, password);

  doSignInWithEmailAndPassword = (email, password) =>
    this.auth.signInWithEmailAndPassword(email, password);

  doSignInWithGoogle = () => this.auth.signInWithPopup(this.googleProvider);

  doSignInWithFacebook = () => this.auth.signInWithPopup(this.facebookProvider);

  doSignInWithTwitter = () => this.auth.signInWithPopup(this.twitterProvider);

  doSignOut = () => this.auth.signOut();

  doPasswordReset = email => this.auth.sendPasswordResetEmail(email);

  doSendEmailVerification = () =>
    this.auth.currentUser.sendEmailVerification({
      url: process.env.REACT_APP_CONFIRMATION_EMAIL_REDIRECT
    });

  doPasswordUpdate = password => this.auth.currentUser.updatePassword(password);

  // *** Merge Auth and DB User API *** //

  onAuthUserListener = (next, fallback) =>
    this.auth.onAuthStateChanged(authUser => {
      //console.log("Auth listening");
      if (authUser) {
        this.user(authUser.uid)
          .once("value")
          .then(snapshot => {
            const dbUser = snapshot.val();

            // default empty roles

            // dbUser.roles = {};

            // // merge auth and db user
            // authUser = {
            //   uid: authUser.uid,
            //   email: authUser.email,
            //   emailVerified: authUser.emailVerified,
            //   providerData: authUser.providerData,
            //   ...dbUser,
            // };

            next(authUser);
          });
      } else {
        fallback();
      }
    });

  // *** User API ***

  user = uid => this.db.ref(`users/${uid}`);

  users = () => this.db.ref("users");

  // *** Message API ***

  message = uid => this.db.ref(`messages/${uid}`);

  messages = () => this.db.ref("messages");
}

export default Firebase;



// WEBPACK FOOTER //
// ./src/app/components/Firebase/firebase.js